import { createContext, useContext, useState } from "react";

export const CoinContext = createContext();

// Custom hooks for consumers
export const useCoin = () => useContext(CoinContext);
export const useAvatar = () => {
  const { avatarUrl, setAvatarUrl } = useContext(CoinContext);
  return { avatarUrl, setAvatarUrl };
};

export const CoinProvider = ({ children }) => {
  const [coinBalance, setCoinBalance] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null); // ✅ new state

  return (
    <CoinContext.Provider
      value={{
        coinBalance,
        setCoinBalance,
        avatarUrl,
        setAvatarUrl, // expose setter
      }}
    >
      {children}
    </CoinContext.Provider>
  );
};
